import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Modal from "theme/components/organisms/Modal";
import Button from "theme/components/atoms/Button";
import Form from "theme/components/atoms/Form/Form";
import Stack from "theme/components/atoms/Layout/Stack";
import FormActions from "theme/components/molecules/Form/FormActions";
import SubmitButton from "theme/components/atoms/Button/SubmitButton";
import { ErrorAlert } from "theme/components/molecules/Alert";
import { CreateRequisitionListMutation } from "./CreateRequisitionListMutation.gql";
import { useMutation } from "react-apollo";
import requisitionListSorter from "theme/modules/RequisitionList/requisitionListSorter";
import RequisitionListModalForm from "../RequisitionListModalForm";

const RequisitionListCreateModal = ({
  isOpen,
  onRequestClose,
  onSuccess,
  readQuery,
}) => {
  let [errorMessage, setErrorMessage] = useState(null);

  const [handleCreate, { loading, error }] = useMutation(
    CreateRequisitionListMutation,
    {
      update(store, response) {
        const data = response.data.createRequisitionList;

        if (!data.success) {
          setErrorMessage(data.errorMessage);
          return;
        }

        const storedData = store.readQuery({ query: readQuery });
        store.writeQuery({
          query: readQuery,
          data: {
            me: {
              ...storedData.me,
              requisitionLists: storedData.me.requisitionLists
                .concat([data.requisitionList])
                .sort(requisitionListSorter),
            },
          },
        });
        setErrorMessage(null);
        onSuccess?.(data.requisitionList);
        onRequestClose();
      },
    }
  );

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={
        <FormattedMessage
          id="modules.RequisitionList.Action.create"
          defaultMessage="New requisition list"
        />
      }
    >
      <Form
        onValidSubmit={(data) =>
          handleCreate({ variables: { requisitionList: data } })
        }
      >
        <Stack size="1">
          <RequisitionListModalForm />

          {error && <ErrorAlert>{error.message}</ErrorAlert>}
          {errorMessage && <ErrorAlert>{errorMessage}</ErrorAlert>}

          <FormActions appearance="full">
            <SubmitButton
              state={loading ? "pending" : "default"}
              appearance="primary"
            >
              <FormattedMessage
                id="modules.RequisitionList.Modal.create"
                defaultMessage="Create the requisition list"
              />
            </SubmitButton>
            <Button type="button" onClick={() => onRequestClose()}>
              <FormattedMessage
                id="modules.RequisitionList.Modal.cancel"
                defaultMessage="Cancel"
              />
            </Button>
          </FormActions>
        </Stack>
      </Form>
    </Modal>
  );
};

RequisitionListCreateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  readQuery: PropTypes.any.isRequired,
};

export default RequisitionListCreateModal;
